module.exports = __webpack_public_path__ + "img/optmint.11ee9184.png";